import apiClient from '../services/apiClient';

export default {
	namespaced: true,
	state: {
		subscription: null,
	},
	getters: {
		subscription(state) {
			return state.subscription;
		},
	},
	mutations: {
		SET_SUBSCRIPTION(state, subscription) {
			state.subscription = subscription
		},
		CLEAR_STORE(state) {
			state.subscription = null;
		}
	},
	actions: {
		getSubscriptions({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('settings/subscription/get').then(res => {
					commit('SET_SUBSCRIPTION', res.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			})
		},
		updateSubscriptions({commit}, subscriptionUpdate) {
			return new Promise((resolve, reject) => {
				apiClient.put('settings/subscription/update', subscriptionUpdate).then(res => {
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
